export class SitemapBuilder
{
    private sitemap: SitemapNode[];
    private parent: SitemapNode;

    constructor(sitemap: SitemapNode[], parent: SitemapNode = null)
    {
        this.sitemap = sitemap;
        this.parent = parent;
    }

    public find(...names: string[])
    {
        if (names.length == 0)
            throw new Error(`Empty argument.`);

        let nodes = this.sitemap;
        let name = names.shift();
        let node = null;

        while (name)
        {
            node = nodes.find(p => p.name == name);

            if (node == null)
                throw new Error(`Node with name ${name} cannot be found.`);

            node.children = node.children || [];
            nodes = node.children;
            name = names.shift();
        }

        return new SitemapBuilder(nodes, node);
    }

    public update(callback: (node: SitemapNode) => void)
    {
        if (this.parent == null)
            throw new Error(`No parent node can be found.`);

        callback(this.parent);

        return this;
    }

    public async updateAsync(callback: (node: SitemapNode) => Promise<void>)
    {
        if (this.parent == null)
            throw new Error(`No parent node can be found.`);

        await callback(this.parent);

        return this;
    }

    public push(insert: SitemapNode[])
    {
        this.sitemap.push(...insert);

        return this;
    }

    public unshift(insert: SitemapNode[])
    {
        this.sitemap.unshift(...insert);

        return this;
    }

    public before(name: string, insert: SitemapNode[])
    {
        const index = this.sitemap.findIndex(p => p.name == name);

        this.sitemap.splice(index, 0, ...insert);

        return this;
    }

    public after(name: string, insert: SitemapNode[])
    {
        const index = this.sitemap.findIndex(p => p.name == name);

        this.sitemap.splice(index + 1, 0, ...insert);
    }
}
